var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-1"},[_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('h5',{domProps:{"textContent":_vm._s(_vm.title)}})]),_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }